import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RemoteConfigState } from './remote-config-types';

const remoteConfigSlice = createSlice({
  name: 'remoteConfig',
  initialState: {
    isLoaded: false,
    values: {},
  } as RemoteConfigState,
  reducers: {
    setRemoteConfigState: (_, action: PayloadAction<RemoteConfigState>) => action.payload,
  },
});

export const { setRemoteConfigState } = remoteConfigSlice.actions;
export default remoteConfigSlice.reducer;
